import React, { useEffect, useState } from "react";
import { InputNumber, InputNumberProps } from "antd";

export const NumericInput = (
  props: NumericInputProps & Omit<InputNumberProps, "onChange">
) => {
  const [_value, _setValue] = useState<string>();
  const decimalPlaces = props.decimalPlaces ?? 2;
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimalPlaces,
  });
  const format = (value: any): string => {
    const result = formatter.format(value);
    if (result === "NaN") return "";
    return result;
  };
  const [isMyChange, setIsMyChange] = useState<boolean>(false);

  const handleChange = (value: number | null) => {
    setIsMyChange(true);
    props.onChange!(value ?? undefined);
    _setValue(value?.toString() || "");
  };

  useEffect(() => {
    if (isMyChange) return setIsMyChange(false);

    _setValue(format(props.value));
  }, [props.value]);

  const { onChange, decimalPlaces: _, className, ...otherProps } = props;

  return (
    <InputNumber
      {...otherProps}
      onChange={handleChange as any}
      value={props.value}
      precision={decimalPlaces}
      style={{ width: "100%", ...props.style }}
      className={`numeric-input ${className || ""}`}
      onBlur={(e) => {
        _setValue(format(props.value));
        typeof props.onBlur === "function" && props.onBlur(e);
      }}
      controls={props.controls !== undefined ? props.controls : false}
      wheel={false}
    />
  );
};

interface NumericInputProps {
  style?: React.CSSProperties;
  value?: number;
  onChange?: (value?: number) => void;
  decimalPlaces?: number;
  disabled?: boolean;
  className?: string;
  controls?: boolean;
}
